import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Entity, getManager, In, Raw, Repository } from 'typeorm';
import { Departments } from './departments.entity';
import { DepartmentsAdapter } from './dto/departments.adapter';
import { DepartmentsDTO } from './dto/departments.dto';
import { DepartmentResponseModel, AllDepartmentsResponseModel, EmployeeRequest } from '@gtpl/shared-models/masters';
import { DepartmentRequest } from './dto/department.request';
import { ItemsDetailsResponseModel } from '@gtpl/shared-models/sale-management';
// import { EmployeeService } from '@gtpl/shared-services/masters';
import appSettings from 'apps/services/config';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
@Injectable()
export class DepartmentsService {
    constructor(
      private logService:LogsService,

        @InjectRepository(Departments)
        private departmentsRepository: Repository<Departments>,
        private departmentsAdapter: DepartmentsAdapter,
        // private empNameService :EmployeeService,
    ) { }
    /**
     * create/update department
     * @param departmentsDTO 
     * @param isUpdate 
     * @param request 
     */
    async createDepartment(departmentsDTO: DepartmentsDTO, isUpdate: boolean): Promise<DepartmentResponseModel> {
        try {
            console.log(departmentsDTO);
            // to check whether Department exists with the passed  Department  or not. if isUpdate is false, a check will be done whether a record with the passed Department is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Department  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
                const DepartmentEntity = await this.getDepartmentDetailsWithoutRelations(departmentsDTO.deptName);
                if (DepartmentEntity) {
                    // throw new ErrorResponse(11104, 'Department already exists');     
                    throw new DepartmentResponseModel(false, 11104, "Departments already existed");
                }
                // var notificationStatus='Created';
            } else {
                const DepartmentEntity = await this.getDepartmentDetailsWithoutRelations(departmentsDTO.deptName);
                if (DepartmentEntity) {
                    if (DepartmentEntity.deptId != departmentsDTO.deptId) {
                        // throw new ErrorResponse(11104, 'Department already exists');  
                        throw new DepartmentResponseModel(false, 11104, "Departments already existed");
                    }
                }
            }
            const convertedDepartmentEntity: Departments = this.departmentsAdapter.convertDtoToEntity(departmentsDTO, isUpdate);
            const savedDepartmentEntity: Departments = await this.departmentsRepository.save(convertedDepartmentEntity);
            const savedDepartmentDto: DepartmentsDTO = this.departmentsAdapter.convertEntityToDto(savedDepartmentEntity);
            if (savedDepartmentDto) {
                // generating resposnse
                const response = new DepartmentResponseModel(true, isUpdate ? 11101 : 11100, isUpdate ? 'Department Updated Successfully' : 'Department Created Successfully', savedDepartmentDto);
                const name=isUpdate?'updated':'created'
            const newLogDto = new LogsDto(1,name, 'Departments', savedDepartmentDto.deptId, true, '', isUpdate ? savedDepartmentDto.updatedUser : savedDepartmentDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response;
            } else {
                throw new ErrorResponse(11106, 'Department saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }
    /**
     * get department details
     * @param deptName 
     */
    // @LogActions({isAsync: true})
    async getDepartmentDetailsWithoutRelations(deptName: string): Promise<Departments> {
        // tslint:disable-next-line: typedef
        const DepartmentResponse = await this.departmentsRepository.findOne({
            where: { deptName: Raw(alias => `dept_name = '${deptName}'`) },
        });
        if (DepartmentResponse) {
            return DepartmentResponse;
        } else {
            return null;
        }
    }

    /**
    * gets all departments details  
    * @returns all departments details .
    */

    //  async getAllDepartments(): Promise<AllDepartmentsResponseModel> {
    //     // const page: number = 1;
    //     try {
    //         const departmentsDTO: DepartmentsDTO[] = [];
    //         //retrieves all companies
    //         const departmentsEntities: Departments[] = await this.departmentsRepository.find({ order: { 'deptName': 'ASC' } });
    //         //console.log(departmentsEntities);
    //         if (departmentsEntities) {
    //             // converts the data fetched from the database which of type companies array to type StateDto array.
    //             departmentsEntities.forEach(departmentEntity => {
    //                 const convertedstatesDto: DepartmentsDTO = this.departmentsAdapter.convertEntityToDto(
    //                     departmentEntity
    //                 );
    //                 departmentsDTO.push(convertedstatesDto);
    //             });
    //             const response = new AllDepartmentsResponseModel(true, 11108, "Departments retrieved successfully", departmentsDTO);
    //             return response;
    //         } else {
    //             throw new ErrorResponse(99998, 'Data not found');
    //         }
    //     } catch (err) {
    //         return err;
    //     }
    // }

    async getAllDepartments(): Promise<AllDepartmentsResponseModel> {
        // try{
        //     const departmentsDTO: DepartmentsDTO[] = [];
        //     //retrieves all companies
        //     const DepartmentsEntities: Departments[] = await this.departmentsRepository.find({
        //         order: {createdAt : 'DESC' },
        //     });
        //     if (DepartmentsEntities.length > 0){
        //         DepartmentsEntities.forEach(Entity =>{
        //             const convetrtedDto: DepartmentsDTO = this.departmentsAdapter.convertEntityToDto(Entity);
        //             departmentsDTO.push(convetrtedDto);
        //         });
        //         const
        //     }

        // }

        const manager = getManager()
        let query = `SELECT d.dept_id AS deptId , d.dept_name AS deptName , d.is_active AS isActive,d.created_at AS createdAt,d.created_user AS createdUser , d.updated_user AS updatedUser ,d.updated_at AS updatedAt , d.version_flag AS versionFlag , d.dept_head AS deptHead , ed.employee_name AS deptHeadName FROM ` + appSettings.masters_db + `.departments d
        LEFT JOIN `+ appSettings.masters_db + `.employee_details ed ON ed.employee_id = d.dept_head
        WHERE d.dept_id > 0 ORDER BY createdAt DESC `;

        // query = query + ` ORDER BY endCustomerName `;
        const data = await manager.query(query);
        if (data) {
            const resu = new AllDepartmentsResponseModel(true, 1141, ' Department Data retrieved successfully', data)
            const newLogDto = new LogsDto(1,'view', 'Departments', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
       return resu;
        } else {
            return new AllDepartmentsResponseModel(false, 1121, 'No data')
        }
    }

    async getAllActiveDepartments(): Promise<AllDepartmentsResponseModel> {
        // const page: number = 1;
        try {
            const departmentsDTO: DepartmentsDTO[] = [];
            //retrieves all companies
            const DepartmentsEntities: Departments[] = await this.departmentsRepository.find({
                order: { deptName: 'ASC' }, where: { isActive: true }
            });
            console.log(DepartmentsEntities)
            if (DepartmentsEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                DepartmentsEntities.forEach(departmentsEntity => {
                    const converteddepartmentsDTO: DepartmentsDTO = this.departmentsAdapter.convertEntityToDto(
                        departmentsEntity
                    );
                    departmentsDTO.push(converteddepartmentsDTO);
                });
                const response = new AllDepartmentsResponseModel(true, 11108, "Departments retrieved successfully", departmentsDTO);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        }
        catch (err) {
            return err;
        }
    }

    /**
     * It deactivates Department 
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivateDepartment(departmentReq: DepartmentRequest): Promise<DepartmentResponseModel> {
        try {
            const departmentExists = await this.getDepartmentById(departmentReq.deptId);
            if (departmentExists) {
                if (departmentReq.versionFlag !== departmentExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Department information.Refresh and try again');
                } else {

                    const departmentStatus = await this.departmentsRepository.update(
                        { deptId: departmentReq.deptId },
                        { isActive: departmentReq.isActive, updatedUser: departmentReq.updatedUser });

                    if (departmentExists.isActive) {
                        if (departmentStatus.affected) {
                            const departmentResponse: DepartmentResponseModel = new DepartmentResponseModel(true, 10115, 'Department is de-activated successfully');
                            return departmentResponse;
                        } else {
                            throw new ErrorResponse(10111, 'Department is already deactivated');
                        }
                    } else {
                        if (departmentStatus.affected) {
                            const departmentResponse: DepartmentResponseModel = new DepartmentResponseModel(true, 10114, 'Department is activated successfully');
                            return departmentResponse;
                        } else {
                            throw new ErrorResponse(10112, 'Department is already activated');
                        }
                    }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
    /**
     * get department while passing id
     * @param deptId 
     */
    async getDepartmentById(deptId: number): Promise<Departments> {
        const Response = await this.departmentsRepository.findOne({
            where: { deptId: deptId },
        });
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

    async getDepartmentDataById(ReqId: DepartmentRequest): Promise<DepartmentResponseModel> {
        try {
            const deptEntity = await this.departmentsRepository.findOne({
                where: { deptId: ReqId.deptId }
            });
            if (deptEntity) {
                const savedDepartmentDto: DepartmentsDTO = this.departmentsAdapter.convertEntityToDto(deptEntity);
                const response = new DepartmentResponseModel(true, 11208, 'Department Retrieved Successfully', savedDepartmentDto);
                return response;
            } else {
                const response = new DepartmentResponseModel(false, 11028, 'No data found');
                return response;
                // throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (error) {
            return error;
        }
    }

    async getDepartmentNameByDeptIds(deptReq: number[]) {
        const departmentEntities = await this.departmentsRepository.find({
            select: ['deptId', 'deptName'],
            where: { deptId: In([null, ...deptReq]) }
        });
        if (departmentEntities) {
            const departmentsDTO: DepartmentsDTO[] = [];
            departmentEntities.forEach(departmentsEntity => {
                const converteddepartmentsDTO: DepartmentsDTO = this.departmentsAdapter.convertEntityToDto(
                    departmentsEntity
                );
                departmentsDTO.push(converteddepartmentsDTO);
            });
            const response = new AllDepartmentsResponseModel(true, 11108, "Departments retrieved successfully", departmentsDTO);
            return response;
        } else {
            throw new ErrorResponse(99998, 'Data not found');
        }
    }

}
